import s from"./hasClass.js";function a(a,e){if(a.classList)a.classList.add(e);else if(!s(a,e))if(typeof a.className==="string")a.className=a.className+" "+e;else a.setAttribute("class",(a.className&&a.className.baseVal||"")+" "+e)}export{a as default};
//# sourceMappingURL=addClass.js.map
